import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, useDeferredValue, useMemo, useState } from "react";
import react_dom from "react-dom";
import { ThemeProvider } from "../../theme/ThemeProvider.js";
const PortalOrigin = /*#__PURE__*/ forwardRef((_, ref)=>/*#__PURE__*/ jsx("span", {
        ref: ref,
        "data-portal-origin": true,
        style: {
            display: 'none'
        }
    }));
PortalOrigin.displayName = 'PortalOrigin';
const Portal = ({ children })=>{
    const [originNode, setOriginNode] = useState(null);
    const containerNode = useMemo(()=>originNode?.closest('dialog') ?? document.body, [
        originNode
    ]);
    const deferredContainerNode = useDeferredValue(containerNode);
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(PortalOrigin, {
                ref: setOriginNode
            }),
            /*#__PURE__*/ react_dom.createPortal(children ? /*#__PURE__*/ jsx(ThemeProvider, {
                children: children
            }) : null, deferredContainerNode)
        ]
    });
};
export { Portal };
